import { Injectable } from '@angular/core';

import { map, Observable, of } from 'rxjs';

import { SecurityRole } from '@reg/shared/model';
import { HttpServiceHelper } from '@reg/shared/service/http-service-helper';
import { IJsonApiResponse } from '../json-api/json-api.interface';
import { observableInSeparateThread } from '../helper/observable-helper';

/**
 * Service to get securityRoles
 */
@Injectable()
export class SecurityRoleService {
    private cachedSecurityRoles: SecurityRole[] = null;

    /**
     * Constructor
     */
    constructor(private http: HttpServiceHelper) {
    }

    /**
     * Get all securityRoles
     */
    public getIndex(queryParams: string[] = []): Observable<SecurityRole[]> {
        if (this.cachedSecurityRoles) {
            // if `cachedSecurityRoles` is available just return it as `Observable`
            return observableInSeparateThread(this.cachedSecurityRoles);
        }
        // Make the http request
        let apiUrl: string = `${this.http.configService.getApiBaseUrl()}/security-roles/`;
        apiUrl += this.http.getQueryParameters([], queryParams);

        return this.http.get(apiUrl)
            .pipe(map((response: IJsonApiResponse) => {
                const securityRoles: SecurityRole[] = [];
                const bodyData: any = response.data || [];
                for (const securityRole of bodyData) {
                    securityRoles.push((new SecurityRole()).deserialize(securityRole));
                }
                this.cachedSecurityRoles = securityRoles;
                return this.cachedSecurityRoles;
            }));
    }
}
